//abdullah
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  Input,
  FormGroup,
  CustomInput,
  Label,
} from "reactstrap";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../baseurl";
import axios from "axios";
import { Link } from "react-router-dom";
import { GetIp } from "../../Forms/ShortCutComponents/Get_ip";
import ResponseLoader from "../../Forms/ShortCutComponents/ResponseLoader";
import { csvFileToArray } from "../../Features/Imports/data";
import moment from "moment";
import GeneralItemSheet from "../../Features/Imports/assets/generalItemSheet.xlsx";
import { checkPermission } from "../../../Helper";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

export default function ExcelLoad(props) {
  const username = localStorage.getItem("username");
  const token = localStorage.getItem("token");
  const companyId = localStorage.getItem("companyId");

  const [loadingResponse, setLoadingResponse] = useState(false);
  const [goodRows, setGoodRows] = useState([]);
  const [badRows, setBadRows] = useState([]);
  const [showBadRows, setShowBadRows] = useState(false);
  const [file, setFile] = useState(null);
  const [disableField, setDisableField] = useState(false);
  const [ipCountry, setIpCountry] = useState({ userIp: "", userCountry: "" });
  const [percentageLoader, setPercentageLoader] = useState(false);
  const [showQty, setShowQty] = useState(false);

  useEffect(() => {
    const funCall = async (value) => {
      await asyncRollCheck(value);
    };
    funCall(1);
    getIpCountry();
  }, []);

  const asyncRollCheck = async (value) => {
    let pathname = "/generalItemExcelLoad";
    let status = value;
    return await checkPermission(pathname, status);
  };

  const handleOnChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleOnChangeFile = async () => {
    if (!file) {
      swal({
        title: "File Not Selected!",
        text: "Please Select File",
        icon: "warning",
      });
      return;
    }

    try {
      setLoadingResponse(true);
      const jsonData = await csvFileToArray(file);
      const nonEmptyArrays = jsonData.filter((arr) => arr.length > 0);

      if (nonEmptyArrays.length === 0) {
        throw new Error("The file contains no valid data");
      }

      const keys = nonEmptyArrays[0];
      const dataObjects = nonEmptyArrays.slice(1).map((row) => {
        const obj = {};
        keys.forEach((key, index) => {
          obj[key] = row[index];
        });
        return obj;
      });

      await verifyExcelData(dataObjects);
    } catch (error) {
      setLoadingResponse(false);
      console.error(error);
      swal({
        title: "Error",
        text: error.message || "Failed to process file",
        icon: "error",
      });
    }
  };

  const verifyExcelData = async (data) => {
    if (!data || data.length === 0) {
      swal({
        title: "Error",
        text: "No data to verify",
        icon: "error",
      });
      return;
    }

    setPercentageLoader(true);
    const currentDate = new Date();
    const date = moment(currentDate).format("YYYY-MM-DD");

    try {
      const { userIp, userCountry } = ipCountry;

      const response = await axios.post(
        `${baseurl}/pointOfSale/verifyGeneralItemExcelData`,
        {
          companyId,
          excelData: data,
          date,
          username,
          userIp,
          userCountry,
        },
        {
          headers: {
            authorization: token,
          },
        }
      );

      const responseData = response.data.data || [];
      const isInvalidValue = (value) => {
        return (
          value === null ||
          value === undefined ||
          value === "" ||
          value === "Invalid"
        );
      };

      const groupedGoodRows = responseData
        .map((item, index) => {
          const masterResult = item || {};
          const inputMaster = data[index] || {};
          console.log("masterResult", masterResult);

          const isMasterDataValid = !isInvalidValue(inputMaster.ITEM_TYPE);
          const isItemTypeValid =
            masterResult.ITEM_TYPE_ID !== null &&
            masterResult.ITEM_TYPE_ID !== "more than one";
          const isItemCatValid =
            masterResult.ITEM_CAT_ID !== null &&
            masterResult.ITEM_CAT_ID !== "more than one";
          const isItemSubCatValid =
            masterResult.ITEM_SUB_CAT_ID !== null &&
            masterResult.ITEM_SUB_CAT_ID !== "more than one";
          const isUOMValid =
            masterResult.UOM_ID !== null &&
            masterResult.UOM_ID !== "more than one";
          const hasValidName = !isInvalidValue(inputMaster.ITEM_DESC);
          const hasValidCode = !isInvalidValue(inputMaster.ITEM_CODE);
          const hasValidBarCode = !isInvalidValue(inputMaster.ITEM_BAR_CODE);

          const masterValid =
            isMasterDataValid &&
            isItemTypeValid &&
            isItemCatValid &&
            isItemSubCatValid &&
            isUOMValid &&
            hasValidName &&
            hasValidCode &&
            hasValidBarCode;

          if (!masterValid) return null;

          return {
            ITEM_CODE: inputMaster.ITEM_CODE || "Invalid",
            ITEM_BAR_CODE: inputMaster.ITEM_BAR_CODE || "Invalid",
            ITEM_DESC: inputMaster.ITEM_DESC || "Invalid",
            ITEM_TYPE: inputMaster.ITEM_TYPE || "Invalid",
            ITEM_CAT: inputMaster.ITEM_CAT || "Invalid",
            ITEM_SUB_CAT: inputMaster.ITEM_SUB_CAT || "Invalid",
            UOM: inputMaster.UOM || "Invalid",
            ITEM_TYPE_ID: masterResult.ITEM_TYPE_ID || "Invalid",
            ITEM_CAT_ID: masterResult.ITEM_CAT_ID || "Invalid",
            ITEM_SUB_CAT_ID: masterResult.ITEM_SUB_CAT_ID || "Invalid",
            UOM_ID: masterResult.UOM_ID || "Invalid",
          };
        })
        .filter(Boolean);

      const groupedBadRows = responseData
        .map((item, index) => {
          const masterResult = item || {};
          const inputMaster = data[index] || {};

          const isMasterDataValid = !isInvalidValue(inputMaster.ITEM_TYPE);
          const isItemTypeValid =
            masterResult.ITEM_TYPE_ID !== null &&
            masterResult.ITEM_TYPE_ID !== "more than one";
          const isItemCatValid =
            masterResult.ITEM_CAT_ID !== null &&
            masterResult.ITEM_CAT_ID !== "more than one";
          const isItemSubCatValid =
            masterResult.ITEM_SUB_CAT_ID !== null &&
            masterResult.ITEM_SUB_CAT_ID !== "more than one";
          const isUOMValid =
            masterResult.UOM_ID !== null &&
            masterResult.UOM_ID !== "more than one";
          const hasValidName = !isInvalidValue(inputMaster.ITEM_DESC);
          const hasValidCode = !isInvalidValue(inputMaster.ITEM_CODE);
          const hasValidBarCode = !isInvalidValue(inputMaster.ITEM_BAR_CODE);

          const masterValid =
            isMasterDataValid &&
            isItemTypeValid &&
            isItemCatValid &&
            isItemSubCatValid &&
            isUOMValid &&
            hasValidName &&
            hasValidCode &&
            hasValidBarCode;

          if (masterValid) return null;

          return {
            ...inputMaster,
            ITEM_CODE: inputMaster.ITEM_CODE || "Invalid",
            ITEM_BAR_CODE: inputMaster.ITEM_BAR_CODE || "Invalid",
            ITEM_DESC: inputMaster.ITEM_DESC || "Invalid",
            ITEM_TYPE: inputMaster.ITEM_TYPE || "Invalid",
            ITEM_CAT: inputMaster.ITEM_CAT || "Invalid",
            ITEM_SUB_CAT: inputMaster.ITEM_SUB_CAT || "Invalid",
            UOM: inputMaster.UOM || "Invalid",
            ITEM_TYPE_ID: masterResult.ITEM_TYPE_ID || "Invalid",
            ITEM_CAT_ID: masterResult.ITEM_CAT_ID || "Invalid",
            ITEM_SUB_CAT_ID: masterResult.ITEM_SUB_CAT_ID || "Invalid",
            UOM_ID: masterResult.UOM_ID || "Invalid",
            isInvalidItemType_id: !isItemTypeValid,
            isInvalidName: !hasValidName,
            isInvalidCode: !hasValidCode,
            isInvaliddata: !isMasterDataValid,
            isInvalidBarCode: !hasValidBarCode,
            isInvalidItemCat_id: !isItemCatValid,
            isInvalidItemSubCat_id: !isItemSubCatValid,
            isInvalidUOM_id: !isUOMValid,
          };
        })
        .filter(Boolean);

      setLoadingResponse(false);
      setPercentageLoader(false);
      setGoodRows(groupedGoodRows);
      setBadRows(groupedBadRows);
      setShowQty(true);

      swal({
        title: "Done",
        text: `Excel verification completed. ${groupedGoodRows.length} valid rows, ${groupedBadRows.length} invalid rows.`,
        icon: "success",
      });
    } catch (error) {
      console.error("Error in verifyExcelData:", error);
      setLoadingResponse(false);
      setPercentageLoader(false);

      swal({
        title: "Error",
        text:
          error.response?.data?.message ||
          "Something went wrong, try to refresh the page and try again.",
        icon: "error",
      });
    }
  };

  const getIpCountry = async () => {
    try {
      const res = await GetIp();
      setIpCountry({ userIp: res.ip, userCountry: res.country });
    } catch (error) {
      console.error("Error getting IP country:", error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const currentDate = new Date();
    const date = moment(currentDate).format("DD-MM-YYYY");

    if (goodRows.length === 0) return;

    setLoadingResponse(true);
    try {
      const { userIp, userCountry } = ipCountry;
      await axios.post(
        `${baseurl}/pointOfSale/addImportGeneralItemData`,
        {
          companyId,
          GeneralItem: goodRows,
          username,
          userIp,
          userCountry,
          date,
        },
        {
          headers: {
            authorization: token,
          },
        }
      );

      setLoadingResponse(false);
      swal({
        title: "Saved Successfully!",
        text: "Item General Item Added",
        icon: "success",
      });
      setDisableField(true);
    } catch (error) {
      console.error("Error:", error);
      setLoadingResponse(false);
      swal({
        title: "Error",
        text: "Something went wrong, try to refresh the page and try again.",
        icon: "error",
      });
    }
  };

  const headers = [
    "Item Code",
    "Item BarCode",
    "Item Name",
    "Item Type",
    "Item Category",
    "Item SubCategory",
    "UOM",
    "Item Type Id",
    "Item Categpry Id",
    "Item SubCategory Id",
    "Item UOM Id",
  ];

  return (
    <>
      {loadingResponse || percentageLoader ? (
        <ResponseLoader percentage={percentageLoader} />
      ) : (
        <div>
          <Row className="Creative-Invoice-header-styling">
            <Col xs="6" className="card-header-Creative-Invoice">
              <strong>
                <h4>Import General Item Sheet</h4>
              </strong>
            </Col>
            <Col xs="6" className="card-header-Creative-Invoice">
              <div style={{ textAlign: "right" }}>
                <Link
                  to="/journalItemOV"
                  style={{
                    fontFamily: "Times New Roman",
                    fontWeight: "normal",
                    margin: "10px",
                  }}
                >
                  <u className="Back-to-Overview">Back to Overview</u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-chevron-left mx-2 icon-color"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </div>
            </Col>
          </Row>
          <div className="mt-3">
            <div className="row">
              <div className="col-4 mt-1">
                <a href={GeneralItemSheet} download>
                  Download example CSV
                </a>
              </div>
            </div>
            <FormGroup>
              <div className="row">
                <div className="col-11">
                  <CustomInput
                    type="file"
                    id="exampleCustomFileBrowser"
                    name="customFile"
                    accept=".csv,.xlsx"
                    required
                    onChange={handleOnChange}
                  />
                </div>
                <div className="col-1">
                  <span className="d-flex flex-row-reverse">
                    <Button
                      className="mr-1 btn-outline-primary"
                      onClick={handleOnChangeFile}
                    >
                      Import
                    </Button>
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-3">
                  <Button
                    hidden={goodRows.length === 0 && badRows.length === 0}
                    className={`mr-1 mt-1 ${
                      showBadRows ? "btn-outline-success" : "btn-outline-danger"
                    }`}
                    onClick={() => setShowBadRows(!showBadRows)}
                  >
                    Show {showBadRows ? "Good" : "Bad"} Rows
                  </Button>
                </div>
                {showQty && (
                  <div className="col-4 mt-2">
                    <span style={{ color: "green" }}>
                      No of Good Rows: {goodRows.length}
                    </span>
                    &nbsp;
                    <span style={{ color: "red" }}>
                      No of Bad Rows: {badRows.length}
                    </span>
                  </div>
                )}
              </div>
            </FormGroup>

            <div style={{ overflowX: "auto" }}>
              <table className="table">
                <thead>
                  {showQty && (
                    <tr>
                      {headers.map((header, index) => (
                        <th style={{ border: "1px solid black" }} key={index}>
                          {header}
                        </th>
                      ))}
                    </tr>
                  )}
                </thead>
                <tbody>
                  {(showBadRows ? badRows : goodRows).map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td
                        style={{
                          backgroundColor:
                            row.ITEM_CODE === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.ITEM_CODE}
                      </td>

                      <td
                        style={{
                          backgroundColor:
                            row.ITEM_BAR_CODE === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.ITEM_BAR_CODE}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.ITEM_DESC === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.ITEM_DESC}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.ITEM_TYPE_ID === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.ITEM_TYPE}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.ITEM_CAT_ID === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.ITEM_CAT}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.ITEM_SUB_CAT_ID === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.ITEM_SUB_CAT}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.UOM_ID === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.UOM}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.ITEM_TYPE_ID === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.ITEM_TYPE_ID}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.ITEM_CAT_ID === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.ITEM_CAT_ID}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.ITEM_SUB_CAT_ID === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.ITEM_SUB_CAT_ID}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.UOM_ID === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.UOM_ID}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <hr
              style={{
                border: "1px solid",
                marginBottom: "3vh",
                marginTop: "1vh",
                borderColor: "#E4E5E6",
              }}
            />

            <div className="col-md-12 d-flex flex-row-reverse">
              <FormGroup>
                <Button
                  onClick={handleSubmit}
                  className="mr-1 invoiceSubmitButton"
                  hidden={goodRows.length === 0}
                  disabled={disableField}
                >
                  Save Changes
                </Button>
                <Link to={{ pathname: "/journalItemOV" }}>
                  <Button className="mr-1" size="sm">
                    Cancel
                  </Button>
                </Link>
              </FormGroup>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
